module.exports = function getResource(label, vars = []) {
    const resources = {
        galleryActivity: 'Activité de la galerie',
        photos: 'Photos',
        noPhotos: `${vars[0]} n’a pas encore de photos.`,
        lovedPhotos: 'Photos favorites',
        noLovedPhotos: `${vars[0]} n’a pas encore aimé de photos.`,
        exploreTheGallery: 'Explorer la galerie'
    };
    return resources[label];
};
